import {
  faArrowDown,
  faBan,
  faCheck,
  faTriangleExclamation
} from '@fortawesome/pro-light-svg-icons';
import { KidsRatioResponse } from 'generated';

import { Box, Collapse } from '@mui/material';

import { FontAwesomeSvgIcon } from 'components/shared';

const STATUS = {
  COLORS: {
    neutral: '#CBEDF9',
    success: '#92CF56',
    error: '#F3B3B2',
    forbidden: '#F3B3B2'
  },
  ICONS: {
    neutral: faArrowDown,
    success: faCheck,
    error: faTriangleExclamation,
    forbidden: faBan
  }
};

export default function StatusBlock({
  expanded,
  ratio
}: {
  ratio: KidsRatioResponse | undefined;
  expanded: boolean;
}) {
  const balance = ratio?.employeeBalance;
  const status =
    balance === 0
      ? 'success'
      : !balance
      ? 'forbidden'
      : balance > 0
      ? 'neutral'
      : 'error';

  return (
    <Box
      flex="1"
      sx={{
        display: 'grid',
        placeItems: 'center'
      }}
      textAlign="center"
      bgcolor={STATUS.COLORS[status]}
      py={1}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
      >
        <FontAwesomeSvgIcon
          sx={{ flex: 1, paddingLeft: '15px' }}
          icon={STATUS.ICONS[status]}
          fontSize="small"
        />
        <Box flex={1} sx={{ paddingRight: '15px' }}>
          {ratio?.kidDistribution?.total ?? 0}
        </Box>
      </Box>
      <Collapse in={expanded}>
        <Box mt={1} fontSize="14px">
          {balance ?? '-'}
        </Box>
      </Collapse>
    </Box>
  );
}
